export const environment = {
  production: false,
  portalApiUrl: 'http://localhost:3000',
  portalApiKey: '',
  region: 'eu-west-1',
  cookieDomain: 'localhost',
  apps: {
    ihm:     { name: 'IHMM',        url: 'https://ihmdev.varuna-sentinels.com',     icon: 'directions_boat', color: '#335596' },
    cbt:     { name: 'CBT',         url: 'https://cbtdev.varuna-sentinels.com',     icon: 'school',          color: '#7b1fa2' },
    lca:     { name: 'LCA',         url: 'https://lcadev.varuna-sentinels.com',     icon: 'eco',             color: '#2e7d32' },
    mps:     { name: 'MPS',         url: 'https://mpsdev.varuna-sentinels.com',     icon: 'inventory_2',     color: '#e65100' },
    esg:     { name: 'ESG',         url: 'https://esgdev.varuna-sentinels.com',     icon: 'nature_people',   color: '#00838f' },
    tracker: { name: 'IHM Tracker', url: 'https://trackerdev.varuna-sentinels.com', icon: 'track_changes',   color: '#c62828' },
  },
  assetsLink: 'https://ihm-cdn-dev.varuna-sentinels.com/assets/',
};
